export interface BillApprovalChainOptionConstructor {
  id: number
  name: string
}

export class BillApprovalChainOption {
  readonly id: number
  readonly name: string

  constructor(data: BillApprovalChainOptionConstructor) {
    this.id = data.id
    this.name = data.name
  }
}
